var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"InfoCounter",class:{
    'InfoCounter--lg': _vm.highestCountAcrossInfoComponents >= 10 && _vm.highestCountAcrossInfoComponents <= 99,
    'InfoCounter--xl': _vm.highestCountAcrossInfoComponents >= 100,
    'InfoCounter--zero': _vm.count === 0
  }},[_vm._t("default",function(){return [_vm._v(" "+_vm._s(_vm.count)+" ")]})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }